/** @format */

import { Box } from '@mui/material';

const SplashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      bgcolor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}>
    <Box width={80}>
      <span className="loader-progress" />
    </Box>
  </Box>
);

export default SplashScreen;
